import type { ReactNode } from "react";
import Box from "@mui/material/Box";
import type { ReportUploadKind } from "@/api/report/_models/ReportUpload";
import { SnapshotDropzone } from "./snapshot-dropzone/SnapshotDropzone";
import { SnapshotSectionProvider } from "./snapshotSection.context";

interface SnapshotSectionProps {
  /** The report files dropped here belong to; never guessed from a file's name. */
  report: ReportUploadKind;
  label: string;
  children?: ReactNode;
}

/**
 * One report on a Snapshot page: its SnapshotSectionProvider around its drop zone. Children are
 * extra header buttons, which can read the section with useSnapshotSection.
 *
 *   <SnapshotSection label="eStore stock" report="estore-inventory">
 *     <InventorySnapshotEstorePull />
 *   </SnapshotSection>
 */
export const SnapshotSection = (props: SnapshotSectionProps) => {
  const { report, label, children } = props;

  return (
    <SnapshotSectionProvider
      label={label}
      report={report}
    >
      <Box sx={{ flexShrink: 0 }}>
        <SnapshotDropzone>{children}</SnapshotDropzone>
      </Box>
    </SnapshotSectionProvider>
  );
};
